import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0a786ec2&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=0a786ec2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a786ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a786ec2')) {
      api.createRecord('0a786ec2', component.options)
    } else {
      api.reload('0a786ec2', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=0a786ec2&scoped=true", function () {
      api.rerender('0a786ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/detail.vue"
export default component.exports